import { z } from 'zod'

export const GetPerformanceInsightsQuery = z.object({
  date: z.string().date(),
  marketMakerId: z.string().nullish(),
  exchangeId: z.string().nullish(),
  orderBook: z.string().nullish(),
  daysLookback: z.coerce.number().int().positive().optional(),
})

export type GetPerformanceInsightsQueryType = z.infer<typeof GetPerformanceInsightsQuery>

export const GetPerformanceInsightsResult = z.array(
  z.object({
    makerTakerPercentage: z.number().safe(),
    allMmBidAsk200bpsPercentage: z.number().safe(),
    avgSpread: z.number().safe().nullish(),
  }),
)
